.text {
  display: flex;
  justify-content: center;
  color: var(--tuna-palette-text-disabled);
}
